export default "__VITE_PUBLIC_ASSET__7de889e4__"